/* pdp_video_lazy.js — defer heavy product videos until user scrolls or taps.
 *
 * Audit on 2026-05-24 found 34 admin-app PDPs ship 2-25 MB of video per page,
 * all autoplay+preload, served from self-hosted Supabase (no CDN edge). On
 * mobile 4G this blocks first paint for 5-10s and explains why funnel
 * Click→ATC sits at 0.4% vs the 3-5% RO baby benchmark.
 *
 * What this does:
 *  - For every <video> whose <source src> contains "supabase.infantcare.uk"
 *    or "supabase-api.infantcare.uk":
 *      • Strip autoplay attribute
 *      • Force preload="none" (browser only fetches metadata when user plays)
 *      • Move actual src to data-src
 *      • Replace with poster image if the <video poster> attribute is set
 *      • Wire IntersectionObserver: when video enters viewport,
 *        restore src + preload="metadata" so it's ready by the time user taps play
 *
 *  - Safe: runs only on /products/* URLs, wrapped in try/catch — must never
 *    break the storefront.
 */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var SUPABASE_HOSTS = ['supabase.infantcare.uk', 'supabase-api.infantcare.uk'];

  function isHeavyVideo(src) {
    if (!src) return false;
    for (var i = 0; i < SUPABASE_HOSTS.length; i++) {
      if (src.indexOf(SUPABASE_HOSTS[i]) !== -1) return true;
    }
    return false;
  }

  function getFlickity(el) {
    if (!el) return null;
    try {
      if (window.Flickity && window.Flickity.data) {
        var direct = window.Flickity.data(el);
        if (direct) return direct;
      }
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.flickity) {
        return window.jQuery(el).data('flickity') || null;
      }
    } catch (_) {}
    return null;
  }

  function refreshFlickity(el, selectedIndex) {
    try {
      var flkty = getFlickity(el);
      if (!flkty) return;
      var index = typeof selectedIndex === 'number' ? selectedIndex : flkty.selectedIndex;
      if (flkty.options) {
        flkty.options.wrapAround = true;
      }
      if (flkty.reloadCells) flkty.reloadCells();
      if (typeof index === 'number' && flkty.cells && flkty.cells.length) {
        flkty.select(Math.max(0, Math.min(index, flkty.cells.length - 1)), false, true);
      }
      if (flkty.resize) flkty.resize();
      if (flkty.updatePrevNextButtons) flkty.updatePrevNextButtons();
    } catch (_) {}
  }

  function moveNativeProductVideoFirst() {
    try {
      var mains = document.querySelectorAll('[data-product-slider-main-wrapper]');
      for (var i = 0; i < mains.length; i++) {
        var main = mains[i];
        var nativeVideo = main.querySelector(
          '.yv-product-video-item[id^="media-main-"]:not([id^="media-main-metafield-video"])'
        );
        if (!nativeVideo) continue;
        if (main.dataset.infantNativeVideoOrdered === '1') continue;

        var changed = false;

        var staleMetafieldVideo = main.querySelector('[id^="media-main-metafield-video"]');
        if (staleMetafieldVideo && staleMetafieldVideo.parentNode) {
          staleMetafieldVideo.parentNode.removeChild(staleMetafieldVideo);
          changed = true;
        }

        if (main.firstElementChild !== nativeVideo) {
          main.insertBefore(nativeVideo, main.firstElementChild);
          changed = true;
        }
        if (main.classList.contains('flickity-enabled') && nativeVideo.parentElement === main) {
          nativeVideo.style.setProperty('left', '0px', 'important');
          nativeVideo.style.setProperty('right', 'auto', 'important');
          nativeVideo.style.setProperty('transform', 'none', 'important');
        }
        if (!main.classList.contains('flickity-enabled')) {
          main.scrollLeft = 0;
        }
        if (changed) refreshFlickity(main, 0);
        main.dataset.infantNativeVideoOrdered = '1';

        var mediaId = nativeVideo.id.replace('media-main-', '');
        var thumb = document.getElementById('media-thumb-' + mediaId);
        var thumbContainer = thumb && thumb.closest('.data-thumb-slider, .yv-product-small-slider');
        if (thumbContainer) {
          var thumbChanged = false;
          var staleThumb = thumbContainer.querySelector('[id^="media-thumb-metafield-video"]');
          if (staleThumb && staleThumb.parentNode) {
            staleThumb.parentNode.removeChild(staleThumb);
            thumbChanged = true;
          }
          if (thumbContainer.firstElementChild !== thumb) {
            thumbContainer.insertBefore(thumb, thumbContainer.firstElementChild);
            thumbChanged = true;
          }
          if (thumbChanged) refreshFlickity(thumbContainer, 0);
        }
      }
    } catch (_) {}
  }

  function syncThumbSelection(wrapper, mediaId) {
    try {
      if (!wrapper) return;
      if (!mediaId) {
        var selected = wrapper.querySelector('[data-product-slider-main-wrapper] .yv-product-slider-item[id^="media-main-"].is-selected');
        mediaId = selected && selected.id.replace('media-main-', '');
      }
      if (!mediaId) return;
      var thumbs = wrapper.querySelectorAll('.gallery__slide-img[id^="media-thumb-"]');
      for (var i = 0; i < thumbs.length; i++) {
        var isMatch = thumbs[i].id === 'media-thumb-' + mediaId;
        thumbs[i].classList.toggle('is-selected', isMatch);
        thumbs[i].classList.toggle('is-nav-selected', isMatch);
      }
    } catch (_) {}
  }

  function getMobileSlides(main) {
    if (!main) return [];
    return Array.prototype.slice.call(main.querySelectorAll('.yv-product-slider-item[id^="media-main-"]'));
  }

  function getClosestMobileSlideIndex(main) {
    var slides = getMobileSlides(main);
    if (!slides.length) return 0;
    var current = 0;
    var best = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var distance = Math.abs(slides[i].offsetLeft - main.scrollLeft);
      if (distance < best) {
        best = distance;
        current = i;
      }
    }
    return current;
  }

  function selectMobileSlide(wrapper, index, smooth) {
    try {
      var main = wrapper && wrapper.querySelector('[data-product-slider-main-wrapper]');
      var slides = getMobileSlides(main);
      if (!main || !slides.length) return;
      var nextIndex = ((index % slides.length) + slides.length) % slides.length;
      var target = slides[nextIndex];
      for (var i = 0; i < slides.length; i++) {
        var selected = slides[i] === target;
        slides[i].classList.toggle('is-selected', selected);
      }
      main.scrollTo({
        left: target.offsetLeft,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
      syncThumbSelection(wrapper, target.id.replace('media-main-', ''));
    } catch (_) {}
  }

  function configureMobileSwipeGallery() {
    try {
      var wrappers = document.querySelectorAll('.product-detail-slider.main-slider-wrapper');
      for (var w = 0; w < wrappers.length; w++) {
        (function (wrapper) {
          var main = wrapper.querySelector('[data-product-slider-main-wrapper]');
          if (!main || main.dataset.infantMobileSwipeBound === '1') return;
          main.dataset.infantMobileSwipeBound = '1';
          main.style.setProperty('overflow-x', 'hidden', 'important');
          main.style.setProperty('touch-action', 'pan-y', 'important');
          var startX = 0;
          var startY = 0;
          var active = false;
          var horizontal = false;

          main.addEventListener('touchstart', function (event) {
            if (!event.touches || event.touches.length !== 1) return;
            active = true;
            horizontal = false;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          }, { capture: true, passive: true });

          main.addEventListener('touchmove', function (event) {
            if (!active || !event.touches || event.touches.length !== 1) return;
            var dx = event.touches[0].clientX - startX;
            var dy = event.touches[0].clientY - startY;
            if (!horizontal && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.25) {
              horizontal = true;
            }
            if (horizontal) {
              event.preventDefault();
            }
          }, { capture: true, passive: false });

          main.addEventListener('touchend', function (event) {
            if (!active) return;
            active = false;
            var touch = event.changedTouches && event.changedTouches[0];
            if (!touch) return;
            var dx = touch.clientX - startX;
            var dy = touch.clientY - startY;
            if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
            event.preventDefault();
            var current = getClosestMobileSlideIndex(main);
            selectMobileSlide(wrapper, current + (dx < 0 ? 1 : -1), true);
          }, { capture: true, passive: false });
        })(wrappers[w]);
      }
    } catch (_) {}
  }

  function selectMediaFromThumb(wrapper, thumb, event) {
    try {
      if (!wrapper || !thumb || !thumb.id) return;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }

      var mediaId = thumb.id.replace('media-thumb-', '');
      var main = wrapper.querySelector('[data-product-slider-main-wrapper]');
      var target = main && document.getElementById('media-main-' + mediaId);
      if (!main || !target) return;

      var mainFlkty = getFlickity(main);
      if (mainFlkty && mainFlkty.cells) {
        var targetIndex = -1;
        for (var i = 0; i < mainFlkty.cells.length; i++) {
          if (mainFlkty.cells[i].element === target) {
            targetIndex = i;
            break;
          }
        }
        if (targetIndex >= 0) {
          mainFlkty.select(targetIndex, false, true);
        }
      } else {
        var slides = main.querySelectorAll('.yv-product-slider-item[id^="media-main-"]');
        for (var j = 0; j < slides.length; j++) {
          var isTarget = slides[j] === target;
          slides[j].classList.toggle('is-selected', isTarget);
          slides[j].style.opacity = isTarget ? '1' : '0';
          slides[j].style.zIndex = isTarget ? '1' : '0';
        }
      }

      var thumbSlider = wrapper.querySelector('.data-thumb-slider, .yv-product-small-slider');
      var thumbFlkty = getFlickity(thumbSlider);
      if (thumbFlkty && thumbFlkty.cells) {
        for (var k = 0; k < thumbFlkty.cells.length; k++) {
          if (thumbFlkty.cells[k].element === thumb) {
            thumbFlkty.select(k, false, true);
            break;
          }
        }
      }

      syncThumbSelection(wrapper, mediaId);
      setTimeout(function () { syncThumbSelection(wrapper, mediaId); }, 60);
    } catch (_) {}
  }

  function configureGalleryControls() {
    try {
      var wrappers = document.querySelectorAll('.product-detail-slider.main-slider-wrapper');
      for (var w = 0; w < wrappers.length; w++) {
        (function (wrapper) {
          var main = wrapper.querySelector('[data-product-slider-main-wrapper]');
          var mainFlkty = getFlickity(main);
          if (mainFlkty && mainFlkty.options) {
            mainFlkty.options.wrapAround = true;
            if (mainFlkty.updatePrevNextButtons) mainFlkty.updatePrevNextButtons();
          }
          if (mainFlkty && mainFlkty.on && main.dataset.infantGalleryChangeBound !== '1') {
            mainFlkty.on('change', function () {
              syncThumbSelection(wrapper);
              setTimeout(function () { syncThumbSelection(wrapper); }, 60);
            });
            main.dataset.infantGalleryChangeBound = '1';
          }

          var buttons = wrapper.querySelectorAll('.flickity-button, .flickity-prev-next-button');
          for (var b = 0; b < buttons.length; b++) {
            buttons[b].style.setProperty('z-index', '2147483001', 'important');
            buttons[b].style.setProperty('pointer-events', 'auto', 'important');
          }

          var thumbs = wrapper.querySelectorAll('.gallery__slide-img[id^="media-thumb-"]');
          for (var t = 0; t < thumbs.length; t++) {
            if (thumbs[t].dataset.infantThumbBound === '1') continue;
            thumbs[t].addEventListener('click', function (event) {
              selectMediaFromThumb(wrapper, this, event);
            }, true);
            thumbs[t].dataset.infantThumbBound = '1';
          }
          syncThumbSelection(wrapper);
        })(wrappers[w]);
      }
    } catch (_) {}
  }

  function toggleNativeVideoPlayback(video) {
    try {
      if (!video) return;
      video.controls = true;
      video.defaultMuted = false;
      video.muted = false;
      video.volume = 1;
      video.removeAttribute('muted');
      if (video.paused || video.ended) {
        var result = video.play();
        if (result && typeof result.catch === 'function') {
          result.catch(function () {});
        }
      } else {
        video.pause();
      }
    } catch (_) {}
  }

  function normalizeNativeProductVideos() {
    try {
      var merchantWidget = document.getElementById('merchantwidgetiframe');
      if (merchantWidget) {
        merchantWidget.style.setProperty('pointer-events', 'none', 'important');
      }
      var merchantWidgetWrapper = document.getElementById('google-merchantwidget-iframe-wrapper');
      if (merchantWidgetWrapper) {
        merchantWidgetWrapper.style.setProperty('pointer-events', 'none', 'important');
      }
      var thumbContainers = document.querySelectorAll('.product-detail-slider.main-slider-wrapper .yv-product-small-slider-container');
      for (var t = 0; t < thumbContainers.length; t++) {
        thumbContainers[t].style.setProperty('z-index', '2147483000', 'important');
        thumbContainers[t].style.setProperty('bottom', '88px', 'important');
        thumbContainers[t].style.setProperty('background', 'rgba(255, 255, 255, 0.78)', 'important');
        thumbContainers[t].style.setProperty('border-radius', '10px', 'important');
        thumbContainers[t].style.setProperty('box-shadow', '0 8px 24px rgba(0, 0, 0, 0.16)', 'important');
        thumbContainers[t].style.setProperty('padding', '6px', 'important');
        thumbContainers[t].style.setProperty('pointer-events', 'auto', 'important');
      }
      var mediaElements = document.querySelectorAll([
        '.product-detail-slider.main-slider-wrapper .yv-product-slider-item[id^="media-main-"]',
        '.product-detail-slider.main-slider-wrapper .yv-product-slider-item[id^="media-main-"] img',
        '.product-detail-slider.main-slider-wrapper .yv-product-slider-item[id^="media-main-"] video',
        '.product-detail-slider.main-slider-wrapper .yv-product-slider-item[id^="media-main-"] iframe',
        '.product-detail-slider.main-slider-wrapper .gallery__slide-img',
        '.product-detail-slider.main-slider-wrapper .gallery__slide-img img'
      ].join(','));
      for (var m = 0; m < mediaElements.length; m++) {
        mediaElements[m].style.setProperty('border-radius', '10px', 'important');
        mediaElements[m].style.setProperty('overflow', 'hidden', 'important');
      }
      var videos = document.querySelectorAll('.yv-product-video-item[id^="media-main-"] video');
      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        video.controls = true;
        video.autoplay = false;
        video.defaultMuted = false;
        video.muted = false;
        video.volume = 1;
        video.removeAttribute('autoplay');
        video.removeAttribute('muted');
        video.style.setProperty('z-index', '20', 'important');
        video.style.setProperty('pointer-events', 'auto', 'important');
        if (video.dataset.infantControlsVersion === '2') continue;
        (function (player) {
          var touchStartX = 0;
          var touchStartY = 0;
          var touchMoved = false;
          var lastTouchToggleAt = 0;

          player.addEventListener('touchstart', function (event) {
            if (event.touches && event.touches.length === 1) {
              touchMoved = false;
              touchStartX = event.touches[0].clientX;
              touchStartY = event.touches[0].clientY;
            }
            event.stopPropagation();
          }, true);

          player.addEventListener('touchmove', function (event) {
            if (event.touches && event.touches.length === 1) {
              var dx = event.touches[0].clientX - touchStartX;
              var dy = event.touches[0].clientY - touchStartY;
              if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
                touchMoved = true;
              }
            }
            event.stopPropagation();
          }, true);

          player.addEventListener('touchend', function (event) {
            event.stopPropagation();
            if (event.defaultPrevented || touchMoved) return;
            event.preventDefault();
            lastTouchToggleAt = Date.now();
            toggleNativeVideoPlayback(player);
          }, true);

          player.addEventListener('click', function (event) {
            event.stopPropagation();
            event.preventDefault();
            if (Date.now() - lastTouchToggleAt < 700) return;
            toggleNativeVideoPlayback(player);
          }, true);

          ['pointerdown', 'pointerup', 'mousedown', 'mouseup'].forEach(function (eventName) {
            player.addEventListener(eventName, function (event) {
              event.stopPropagation();
            }, true);
          });
        })(video);
        video.dataset.infantControlsBound = '1';
        video.dataset.infantControlsVersion = '2';
      }
    } catch (_) {}
  }

  function deferVideo(videoEl) {
    try {
      // Find heavy source elements inside this <video>
      var sources = videoEl.querySelectorAll('source');
      var anyHeavy = false;
      for (var i = 0; i < sources.length; i++) {
        var s = sources[i];
        var src = s.getAttribute('src') || '';
        if (isHeavyVideo(src)) {
          anyHeavy = true;
          s.setAttribute('data-src', src);
          s.removeAttribute('src');
        }
      }
      // Also check <video src=...>
      var vSrc = videoEl.getAttribute('src') || '';
      if (isHeavyVideo(vSrc)) {
        anyHeavy = true;
        videoEl.setAttribute('data-src', vSrc);
        videoEl.removeAttribute('src');
      }
      if (!anyHeavy) return;

      // Disable autoplay + preload for heavy videos
      videoEl.removeAttribute('autoplay');
      videoEl.autoplay = false;
      videoEl.preload = 'none';
      videoEl.setAttribute('preload', 'none');
      // Force load() to clear network buffer
      try { videoEl.load(); } catch (_) {}
      videoEl.dataset.lazyDeferred = '1';
    } catch (_) {}
  }

  function activateVideo(videoEl) {
    try {
      if (videoEl.dataset.lazyActivated === '1') return;
      videoEl.dataset.lazyActivated = '1';
      // Restore source URLs
      var sources = videoEl.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
      }
      var vDataSrc = videoEl.getAttribute('data-src');
      if (vDataSrc) videoEl.setAttribute('src', vDataSrc);
      // Allow browser to prefetch the file metadata
      videoEl.preload = 'metadata';
      videoEl.setAttribute('preload', 'metadata');
      try { videoEl.load(); } catch (_) {}
    } catch (_) {}
  }

  function scanAndDefer() {
    try {
      moveNativeProductVideoFirst();
      configureGalleryControls();
      configureMobileSwipeGallery();
      normalizeNativeProductVideos();
      var vids = document.querySelectorAll('video');
      for (var i = 0; i < vids.length; i++) {
        deferVideo(vids[i]);
      }
      // Observe — restore src when within 400px of viewport
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.target.dataset && e.target.dataset.lazyDeferred === '1') {
              activateVideo(e.target);
              obs.unobserve(e.target);
            }
          });
        }, { rootMargin: '400px 0px 400px 0px' });
        for (var j = 0; j < vids.length; j++) {
          if (vids[j].dataset && vids[j].dataset.lazyDeferred === '1') obs.observe(vids[j]);
        }
      } else {
        // No IO support — activate after 4s as fallback
        setTimeout(function () {
          for (var k = 0; k < vids.length; k++) {
            if (vids[k].dataset && vids[k].dataset.lazyDeferred === '1') activateVideo(vids[k]);
          }
        }, 4000);
      }
    } catch (_) {}
  }

  // Run before browser starts fetching: as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndDefer);
  } else {
    scanAndDefer();
  }
  // Re-scan in case theme adds more videos dynamically (slider, etc.)
  setTimeout(scanAndDefer, 1500);
  setTimeout(scanAndDefer, 4000);
})();
